<template>
	<div class>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-copy"></i> 牌照审核 / 总部业务员
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="总部业务员牌照审核" name="first"/>
				<el-tab-pane label="总部业务员车辆变更审核" name="second"/>
				<el-tab-pane label="总部业务员车主变更审核" name="third"/>
				<el-tab-pane label="总部业务员机械牌照修改审核" name="fourth"/>
			</el-tabs>
			
			
			<el-form ref="allLicenselyform" :model="allLicenselyform">
				<div class="apply-flex">
					<p>
						<el-form-item label="车主姓名" prop="ownerName">
							<el-input v-model="allLicenselyform.ownerName" style="width:150px"></el-input>
						</el-form-item>
					</p>
					<p class="apply-flexarea">
						<el-form-item label="区域" prop="provinceId">
							<el-select v-model="allLicenselyform.provinceId" placeholder="请选择省份"
								@change="provinceChange(allLicenselyform)" style="width:150px">
								<el-option v-for="item in provinceOptions" :key="item.provinceId" :label="item.name"
									:value="item.provinceId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label prop="cityId">
							<el-select v-model="allLicenselyform.cityId" placeholder="请选择市区" style="width:150px">
								<el-option v-for="item in citysOptions" :key="item.cityId" :label="item.name"
									:value="item.cityId"></el-option>
							</el-select>
						</el-form-item>
					</p>
				</div>
			</el-form>

			<p class="flex-btn">
				<el-button type="primary" icon="el-icon-search" @click="handleSearch()">查询</el-button>
				<el-button type="primary" icon="el-icon-delete" class="handle-del" @click="passApplyfirst({})">批量通过
				</el-button>
				<el-button type="primary" icon="el-icon-delete" class="handle-del"
					@click="fallbackApplyfirst({},'fallbackform')">批量退回</el-button>
			</p>

			<el-table :data="allLicenselyTableData" border class="table" ref="multipleTable"
				header-cell-class-name="table-header" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="areaName" label="区域" align="center"></el-table-column>
				<el-table-column prop="ownerName" label="车主姓名"></el-table-column>
				<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
				<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
				<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
				<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
				<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
				<el-table-column label="操作" width="180" align="center">
					<template slot-scope="scope">
						
						<el-button type="text" icon="el-icon-view" v-if="activeName=='second' || activeName=='third'">
							<router-link :to="'/seelicensecheckfzbfirst/'+scope.row.mechanicsTransactionApplyId+'/'+activeName+'/'+query.pageIndex"
								style="color: #409EFF;">查看</router-link>
						</el-button>
						<el-button type="text" icon="el-icon-view" v-else>
							<router-link :to="'/seelicensecheckfzbfirst/'+scope.row.licenseApplyId+'/'+activeName+'/'+query.pageIndex"
								style="color: #409EFF;">查看</router-link>
						</el-button>
						<el-button type="text" icon @click="passApplyfirst(scope.row)">通过</el-button>
						<el-button type="text" icon @click="fallbackApplyfirst(scope.row,'fallbackform')">退回</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
					:page-size="query.pageSize" :total="pageTotal"
					@current-change="handlePageChange1($event,allLicenselyform)"></el-pagination>
			</div>
		</div>

		<el-dialog class="branch-dialog" title="退回原因" :visible.sync="fallbackVisible" width="600px">
			<el-form ref="fallbackform" :model="fallbackform">
				<el-form-item label prop="auditReason">
					<el-input type="textarea" v-model="fallbackform.auditReason" placeholder="请输入回退原因"
						class="resizeNone"></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="fallbackVisible = false">取 消</el-button>
				<el-button type="primary" @click="savefallbackfirst()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		listProvinces,
		listTaskRemindNum,
		listCitysByProvinceId,
		listLicenseApplyExamines,
		examineLicenseApply,
		listMechanicsTransactionApplyExamines,
		listLicenseApplyUpdateExamines,
		examineMechanicsTransactionApply1,
		examineMechanicsTransactionApply
	} from '../api/index';
	export default {
		name: 'licenseapplys',
		data() {
			return {
				provinceOptions: [], //省列表
				citysOptions: [], //市列表
				allLicenselyform: {
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
				}, //所有的搜索表单
				secondLicenselyform: {
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
				},
				thirdLicenselyform: {
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
				},
				fourthLicenselyform: {
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
				},
				query: {
					pageIndex: 1,
					pageSize: 10
				}, //分页
				allLicenselyTableData: [],
				multipleSelection: [],
				pageTotal: 0,

				fallbackVisible: false,
				fallbackform: {
					auditReason: ''
				},
				fallbackArr: [],
				btntagVisible: '',
				activeName: 'first',
			}
		},
		created() {
			this.activeName = this.$route.params.activeName
			this.query.pageIndex = this.$route.params.pageIndex
			var that = this;
			// 省
			listProvinces({}).then(res => {
				// 获取数据成功后的其他操作
				that.provinceOptions = res.data;
			});
			// 牌照审核
			// this.getlistLicenseApplyExamines(); //初始化form为全部allLicenselyform
			
			if (this.activeName == 'first') {
				this.getlistLicenseApplyExamines(this.allLicenselyform);
			} else if (this.activeName == 'second') {
				this.getlistMechanicsTransactionApplyExamines(this.secondLicenselyform, 2)
			} else if (this.activeName == 'third') {
				this.getlistMechanicsTransactionApplyExamines(this.thirdLicenselyform, 1)
			} else if (this.activeName == 'fourth') {
				this.getlistLicenseApplyUpdateExamines();
			}
		},
		methods: {
			// 省改变请求市
			provinceChange(Licenselyform) {
				Licenselyform.cityId = '';
				listCitysByProvinceId({
					provinceId: Licenselyform.provinceId
				}).then(res => {
					// 获取数据成功后的其他操作
					this.citysOptions = res.data;
				});
			},

			// 牌照审核
			getlistLicenseApplyExamines() {
				this.allLicenselyform.organizationKind = 2;
				this.allLicenselyform.current = this.query.pageIndex;
				this.allLicenselyform.size = this.query.pageSize;
				listLicenseApplyExamines(this.allLicenselyform).then(res => {
					// 获取数据成功后的其他操作
					this.allLicenselyTableData = res.data.records;
					this.pageTotal = res.data.total;
				});
			},
			getlistMechanicsTransactionApplyExamines(form, tag) {
				var LicenseApplyobj = {};
				LicenseApplyobj = form;
				LicenseApplyobj.organizationKind = 2;
				LicenseApplyobj.isRetainLicenseNumber = tag;
				LicenseApplyobj.current = this.query.pageIndex;
				LicenseApplyobj.size = this.query.pageSize;
				listMechanicsTransactionApplyExamines(LicenseApplyobj).then(res => {
					// 获取数据成功后的其他操作
					this.allLicenselyTableData = res.data.records;
					this.pageTotal = res.data.total;
				});
			},
			
			//牌照修改审核
			getlistLicenseApplyUpdateExamines() {
				this.fourthLicenselyform.organizationKind = 2;
				this.fourthLicenselyform.current = this.query.pageIndex;
				this.fourthLicenselyform.size = this.query.pageSize;
				this.fourthLicenselyform.provinceId = this.allLicenselyform.provinceId
				this.fourthLicenselyform.cityId = this.allLicenselyform.cityId
				this.fourthLicenselyform.ownerName = this.allLicenselyform.ownerName
				listLicenseApplyUpdateExamines(this.fourthLicenselyform).then(res => {
					// 获取数据成功后的其他操作
					this.allLicenselyTableData = res.data.records;
					this.pageTotal = res.data.total;
				});
			},
			
			
			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.allLicenselyTableData = [];
				if (this.activeName == 'first') {
					this.getlistLicenseApplyExamines(this.allLicenselyform);
				} else if (this.activeName == 'second') {
					this.getlistMechanicsTransactionApplyExamines(this.allLicenselyform, 2)
				} else if (this.activeName == 'third') {
					this.getlistMechanicsTransactionApplyExamines(this.allLicenselyform, 1)
				} else if (this.activeName == 'fourth') {
					this.getlistLicenseApplyUpdateExamines();
				}
				// this.getlistLicenseApplyExamines();
			},


			// 牌照审核通过
			passApplyfirst(row) {
				// 分支机构牌证申购申请表id集合   用于通过or回退
				let licenseApplyIdsArr = [];
				if(this.activeName=='second' || this.activeName=='third') { //车辆变更、车主变更审核
					if(row.mechanicsTransactionApplyId) {  //单个通过
						licenseApplyIdsArr.push(row.mechanicsTransactionApplyId)
					}else { //批量通过
						if(this.multipleSelection.length>0) {
							licenseApplyIdsArr = this.multipleSelection.map(item=>item.mechanicsTransactionApplyId)
						}else {
							this.$message({
								message: '没有选择要通过的选项哦',
								center: true
							});
							return
						}
					}
				}else {
					if(row.licenseApplyId) {  //单个通过
						licenseApplyIdsArr.push(row.licenseApplyId)
					}else { //批量通过
						if(this.multipleSelection.length>0) {
							licenseApplyIdsArr = this.multipleSelection.map(item=>item.licenseApplyId)
						}else {
							this.$message({
								message: '没有选择要通过的选项哦',
								center: true
							});
							return
						}
					}
				}
				let reqFun = ''
				let reqObj = {
					isPass: 1,
				}
				if(this.activeName=='first') { //牌照审核
					reqFun = examineLicenseApply
					reqObj.licenseApplyIds= licenseApplyIdsArr
				}else if(this.activeName=='second') { //车辆变更审核
					reqFun = examineMechanicsTransactionApply1
					reqObj.mechanicsTransactionApplyIds = licenseApplyIdsArr
				}else if(this.activeName=='third') { //车主变更审核
					reqFun = examineMechanicsTransactionApply
					reqObj.mechanicsTransactionApplyIds = licenseApplyIdsArr
				}else if(this.activeName=='fourth') { //机械牌照修改审核
					reqFun = examineLicenseApply
					reqObj.licenseApplyIds= licenseApplyIdsArr
				}
				console.log(reqObj,'请求参数');
				this.$confirm('确定要通过吗？', '提示', {
					type: 'warning'
				}).then(() => {
					reqFun(reqObj).then(res => {
						// 获取数据成功后的其他操作
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.query.pageIndex = 1;
						this.allLicenselyform = {
							ownerName: '', //车主姓名
							provinceId: '',
							cityId: '',
						};
						if (this.activeName == 'first') {
							this.getlistLicenseApplyExamines(this.allLicenselyform);
						} else if (this.activeName == 'second') {
							this.getlistMechanicsTransactionApplyExamines(this.allLicenselyform, 2)
						} else if (this.activeName == 'third') {
							this.getlistMechanicsTransactionApplyExamines(this.allLicenselyform, 1)
						} else if (this.activeName == 'fourth') {
							this.getlistLicenseApplyUpdateExamines();
						}

						listTaskRemindNum({}).then(ress => {
							this.$store.state.totalNum = ress.data.totalNum;
						});
					});
				}).catch(() => {});

			},

			// 删除操作

			// 退回弹框
			fallbackApplyfirst(row, formName) {
				
				let licenseApplyIdsArr = [];
				if(this.activeName=='second' || this.activeName=='third') { //车辆变更、车主变更审核
					if(row.mechanicsTransactionApplyId) {  //单个退回
						licenseApplyIdsArr.push(row.mechanicsTransactionApplyId)
					}else { //批量退回
						if(this.multipleSelection.length>0) {
							licenseApplyIdsArr = this.multipleSelection.map(item=>item.mechanicsTransactionApplyId)
						}else {
							this.$message({
								message: '没有选择要退回的选项哦',
								center: true
							});
							return
						}
					}
				}else {
					if(row.licenseApplyId) {  //单个退回
						licenseApplyIdsArr.push(row.licenseApplyId)
					}else { //批量退回
						if(this.multipleSelection.length>0) {
							licenseApplyIdsArr = this.multipleSelection.map(item=>item.licenseApplyId)
						}else {
							this.$message({
								message: '没有选择要退回的选项哦',
								center: true
							});
							return
						}
					}
				}
				this.fallbackArr = licenseApplyIdsArr;
				this.fallbackVisible = true;
				//重置表单数据
				this.$nextTick(() => {
					this.$refs.[formName].resetFields();
				})
			},

			//退回弹框确定按钮
			savefallbackfirst() {
				let reqFun = ''
				let reqObj = {
					auditReason: this.fallbackform.auditReason,
					isPass: 2,
				}
				if(this.activeName=='first') { //牌照审核
					reqFun = examineLicenseApply
					reqObj.licenseApplyIds= this.fallbackArr
				}else if(this.activeName=='second') { //车辆变更审核
					reqFun = examineMechanicsTransactionApply1
					reqObj.mechanicsTransactionApplyIds = this.fallbackArr
				}else if(this.activeName=='third') { //车主变更审核
					reqFun = examineMechanicsTransactionApply
					reqObj.mechanicsTransactionApplyIds = this.fallbackArr
				}else if(this.activeName=='fourth') { //机械牌照修改审核
					reqFun = examineLicenseApply
					reqObj.licenseApplyIds= this.fallbackArr
				}
				
				console.log(reqObj,'退回操作传参');
				this.$confirm('确定要退回吗？', '提示', {
					type: 'warning'
				}).then(() => {
					reqFun(reqObj).then(res => {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.query.pageIndex = 1;
						this.allLicenselyform = {
							ownerName: '', //车主姓名
							provinceId: '',
							cityId: '',
						};
						if (this.activeName == 'first') {
							this.getlistLicenseApplyExamines(this.allLicenselyform);
						} else if (this.activeName == 'second') {
							this.getlistMechanicsTransactionApplyExamines(this.allLicenselyform, 2)
						} else if (this.activeName == 'third') {
							this.getlistMechanicsTransactionApplyExamines(this.allLicenselyform, 1)
						} else if (this.activeName == 'fourth') {
							this.getlistLicenseApplyUpdateExamines();
						}
						
						this.fallbackVisible = false;
						listTaskRemindNum({}).then(ress => {
							this.$store.state.totalNum = ress.data.totalNum;
						});
					});
				}).catch(() => {});
			},

			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			// 分页
			handlePageChange(val) {
				this.$set(this.query, 'pageIndex', val);
				this.getlistLicenseApplyExamines();
			},
			handleClick(tab, event) {
				this.allLicenselyform = {
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
				};
				// this.secondLicenselyform = {
				// 	ownerName: '', //车主姓名
				// 	provinceId: '',
				// 	cityId: '',
				// };
				// this.thirdLicenselyform = {
				// 	ownerName: '', //车主姓名
				// 	provinceId: '',
				// 	cityId: '',
				// };
				// this.fourthLicenselyform = {
				// 	ownerName: '', //车主姓名
				// 	provinceId: '',
				// 	cityId: '',
				// };
				this.query.pageIndex = 1;
				this.allLicenselyTableData = [];
				if (tab.name == 'first') {
					this.getlistLicenseApplyExamines(this.allLicenselyform);
				} else if (tab.name == 'second') {
					this.getlistMechanicsTransactionApplyExamines(this.allLicenselyform, 2)
				} else if (tab.name == 'third') {
					this.getlistMechanicsTransactionApplyExamines(this.allLicenselyform, 1)
				} else if (tab.name == 'fourth') {
					this.getlistLicenseApplyUpdateExamines();
				}
			}
		},

		computed: {

		},
		
	}
</script>


<style scoped>
	.apply-flex {
		display: flex;
		display: -webkit-flex;
		flex-wrap: wrap;
	}

	.apply-flex p {
		width: 25%;
		margin-right: 20px;
	}

	.apply-flex p.apply-flexarea .el-form-item {
		margin-right: 10px;
	}

	.apply-flex p.apply-flexarea {
		width: 40%;
		display: flex;
		display: -webkit-flex;
	}

	.apply-flex .el-form-item {
		display: flex;
		display: -webkit-flex;
	}

	.flex-btn {
		margin-bottom: 20px;
		text-align: right;
		border-top: 1px solid #ddd;
		padding-top: 10px;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
</style>


<style>
	.apply-flex p .el-form-item__label {
		width: 80px;
	}
</style>
